import { createTranslations } from '@npco/common-utils-translations'

export const crnFieldTranslations = createTranslations({
  label: 'Customer Reference Number',
  errorRequired: 'Customer Reference Number is required.',
  errorNumeric: 'Customer Reference Number must be numeric.',
  errorInputLength:
    'Customer Reference Number must be between 2 and 20 digits.',
})
